import {defaultDataIdFromObject, StoreObject} from '@apollo/client';

import {InaccessibleInfoGraphQL} from '../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';
import {isInaccessible} from './InaccessibleInfo';

function isPartialInaccessibleInfo(
  object: StoreObject
): object is Pick<InaccessibleInfoGraphQL, '__typename'> & Partial<InaccessibleInfoGraphQL> {
  return isInaccessible(object);
}

/**
 * InaccessibleInfo objects do not define an id field, but invalidId instead. The Apollo cache normalizes
 * objects based on `id` by default, so we need to provide an alternate normalization function to make sure
 * InaccessibleInfo objects get correctly cached.
 */
export default function dataIdFromInaccessibleInfoObject(
  responseObject: Readonly<StoreObject>
): string | null | undefined {
  if (isPartialInaccessibleInfo(responseObject)) {
    // NOTE: invalidId may be undefined. Unclear if this behavior is correct.
    return defaultDataIdFromObject({__typename: responseObject.__typename, id: responseObject.invalidId});
  }
  return undefined;
}
